import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  admin: null,
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setAdmin: (state, action) => {
      state.admin = action.payload;
    },
  },
});

export const { setLoading, setAdmin } = adminSlice.actions;

export default adminSlice.reducer;
